/*
 * Mobile navigation scroll bridge.
 *
 * The theme locks the outer mobile drawer to prevent the page behind it from
 * moving. On iOS, body-scroll-lock also needs to know that an opened nested
 * submenu is a valid touch-scroll surface; otherwise the outer drawer can
 * consume the gesture before the submenu receives it.
 */
(() => {
  'use strict';

  const scrollLock = window.bodyScrollLock;

  if (
    !scrollLock ||
    typeof scrollLock.disableBodyScroll !== 'function' ||
    scrollLock.disableBodyScroll.__mpNestedMenuScrollBridge
  ) {
    return;
  }

  const originalDisableBodyScroll = scrollLock.disableBodyScroll;

  scrollLock.disableBodyScroll = function disableBodyScrollWithNestedMenus(
    target,
    options = {}
  ) {
    const originalAllowTouchMove = options.allowTouchMove;

    return originalDisableBodyScroll.call(this, target, {
      ...options,
      allowTouchMove: (element) => {
        const isNestedMenuScrollSurface = Boolean(
          element?.closest?.(
            '#shopify-section-header [data-mobile-menu-panel], ' +
              '#shopify-section-header .mp-mobile-menu'
          )
        );

        return (
          isNestedMenuScrollSurface ||
          (typeof originalAllowTouchMove === 'function' &&
            originalAllowTouchMove(element))
        );
      },
    });
  };

  scrollLock.disableBodyScroll.__mpNestedMenuScrollBridge = true;
})();
